import WholesalerRetentionsView from "views/WholesalerRetentions/WholesalerRetentionsView";
import RetentionOutputsView from "views/RetentionOutputs/RetentionOutputsView";
import MonthlyClosingView from "views/MonthlyClosing/MonthlyClosingView";
import SpecialUnitsView from "views/SpecialUnits/SpecialUnitsView";
import { ActionTypes } from "redux/reducers/wholesalerRetentions/types";
import { ActionTypes as RetentionOutputsActionTypes } from "redux/reducers/retentionOutputs/types";
import { ActionTypes as MonthlyClosingActionTypes } from "redux/reducers/monthlyClosing/types";
import { ActionTypes as SpecialUnitsActionTypes } from "redux/reducers/specialUnits/types";
import { PERMISSIONS } from "router/permissions";

import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";

// Permisos granulares pendientes de implementar en backend:
// WHOLESALE-RETENTIONS, RETENTION-OUTPUTS, MONTHLY-CLOSING
const {
  WITHHOLDINGS,
  WITHHOLDINGS_DEPARTURES,
  WITHHOLDINGS_CLOSING_VIEW,
  WITHHOLDINGS_SPECIAL_UNITS,
} = PERMISSIONS;

export const commissionRoutes = [
  {
    collapse: true,
    name: "Comisionistas",
    icon: PeopleOutlineIcon,
    state: "commissionCollapse",
    inSidebar: true,
    isProtected: true,
    rule: WITHHOLDINGS,
    views: [
      {
        path: "/wholesaler-retentions",
        name: "Retenciones Comisionistas",
        mini: "RC",
        component: WholesalerRetentionsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: WITHHOLDINGS,
        reducer: "wholesalerRetentions",
        restoreKey: ActionTypes.RESTORE_INITIAL,
      },
      {
        path: "/retention-outputs",
        name: "Salidas de Retenciones",
        mini: "SR",
        component: RetentionOutputsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: WITHHOLDINGS_DEPARTURES,
        reducer: "retentionOutputs",
        restoreKey: RetentionOutputsActionTypes.RESTORE_INITIAL,
      },
      {
        path: "/monthly-closing",
        name: "Cierre Mensual Comisionistas",
        mini: "CM",
        component: MonthlyClosingView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: WITHHOLDINGS_CLOSING_VIEW,
        reducer: "monthlyClosing",
        restoreKey: MonthlyClosingActionTypes.RESTORE_INITIAL,
      },
      {
        path: "/unidades-especiales",
        name: "Unidades Especiales",
        mini: "UE",
        component: SpecialUnitsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: WITHHOLDINGS_SPECIAL_UNITS,
        reducer: "specialUnits",
        restoreKey: SpecialUnitsActionTypes.RESTORE_INITIAL,
      },

    ],
  },
];
